import { t } from 'ttag';

export const USER_TYPES = {
  superManager: 1,
  manager: 2,
  trainer: 3,
  sportsmen: 4,
};

export const USER_TYPES_LABEL = {
  [USER_TYPES.superManager]: t`Менеджер клуба`,
  [USER_TYPES.manager]: t`Адміністратор клуба`,
  [USER_TYPES.trainer]: t`Тренер`,
  [USER_TYPES.sportsmen]: t`Спортсмен`,
};

export const USER_STATUS = {
  active: 1,
  deleted: 2,
  dummy: 3,
  archived: 4,
  blocked: 5,
};

export const CONTRIBUTION_STATUS = {
  passed: 1,
  not_passed: 2,
};

export const USER_PERMISSIONS = {
  read_trainers: 1,
  write_trainers: 2,
  read_groups: 3,
  write_groups: 4,
  read_gyms: 5,
  write_gyms: 6,
  read_athletes: 9,
  write_athletes: 10,
  read_contributions: 11,
  write_contributions: 12,
  read_dankai: 26,
  write_dankai: 27,
};

export const GENDER_OPTIONS = [
  { id: '1', label: t`Чоловік` },
  { id: '2', label: t`Жінка` },
];

export const CATEGORY_OPTIONS = [
  { id: 'CATEGORY_1', label: t`1 категорія` },
  { id: 'CATEGORY_2', label: t`2 категорія` },
  { id: 'CATEGORY_3', label: t`3 категорія` },
  { id: 'CATEGORY_HIGH', label: t`Вища категорія` },
];

export const STATUS_STATEMENT = {
  open: 1,
  closed: 2,
};

export const STATUS_STATEMENT_TITLE = {
  [STATUS_STATEMENT.open]: t`Відкрита`,
  [STATUS_STATEMENT.closed]: t`Закрита`,
};

export const CERTIFICATION_ATHLETE_STATUS = {
  dealing: 1,
  re_delivery: 2,
};

export const CERTIFICATION_ATHLETE_STATUS_TITLE = {
  [CERTIFICATION_ATHLETE_STATUS.dealing]: t`Здача`,
  [CERTIFICATION_ATHLETE_STATUS.re_delivery]: t`Перездача`,
};

export const PROTOCOL_STATUS_ATHLETE = {
  passed: 1,
  not_pass: 2,
  pending: 3,
};

export const PROTOCOL_STATUS_ATHLETE_TITLE = {
  [PROTOCOL_STATUS_ATHLETE.passed]: t`Здав`,
  [PROTOCOL_STATUS_ATHLETE.not_pass]: t`Не здав`,
  [PROTOCOL_STATUS_ATHLETE.pending]: t`Очікує`,
};

export const CERTIFICATION_STATUS = {
  open: 1,
  close: 2,
  archivate: 3,
};

export const PROTOCOL_STATUS = {
  open: 1,
  closed: 2,
};

export const CERTIFICATION_STATUS_TITLE = {
  [CERTIFICATION_STATUS.open]: t`Відкритий`,
  [CERTIFICATION_STATUS.close]: t`Закритий`,
  [CERTIFICATION_STATUS.archivate]: t`Архівований`,
};

export const STATUS_PROTOCOL_TITLE = {
  [PROTOCOL_STATUS.open]: t`Відкритий`,
  [PROTOCOL_STATUS.closed]: t`Закритий`,
};

export const BASE_STATUS = {
  active: 1,
  deleted: 2,
  dummy: 3,
  archived: 4,
  blocked: 5,
};

export const BASE_STATUS_TITLES = {
  [BASE_STATUS.active]: t`Активний`,
  [BASE_STATUS.deleted]: t`Видалено`,
  [BASE_STATUS.dummy]: t`Чернетка`,
  [BASE_STATUS.archived]: t`Архівний`,
  [BASE_STATUS.blocked]: t`Заблоковано`,
};

export const CONTRIBUTION_TYPE = {
  athlete: 'athlete',
};

export const QUALIFICATION_OPTIONS = [
  { id: 'ІІІр.', label: t`ІІІр..` },
  { id: 'ІІр.', label: t`ІІр.` },
  { id: 'Ір.', label: t`Ір.` },
  { id: 'КМСУ', label: t`КМСУ` },
  { id: 'МСУ', label: t`МСУ` },
  { id: 'МСУМК', label: t`МСУМК` },
  { id: 'ЗМСУ', label: t`ЗМСУ` },
];

export const RANK_TITLE_MAP = {
  kyu_11: '11 Кю',
  kyu_10: '10 Кю',
  kyu_9: '9 Кю',
  kyu_8: '8 Кю',
  kyu_7: '7 Кю',
  kyu_6: '6 Кю',
  kyu_5: '5 Кю',
  kyu_4: '4 Кю',
  kyu_3: '3 Кю',
  kyu_2: '2 Кю',
  kyu_1: '1 Кю',
  dan_1: '1 Дан',
  dan_2: '2 Дан',
  dan_3: '3 Дан',
  dan_4: '4 Дан',
  dan_5: '5 Дан',
  dan_6: '6 Дан',
  dan_7: '7 Дан',
  dan_8: '8 Дан',
  dan_9: '9 Дан',
  dan_10: '10 Дан',
};

export const RANK_PRIORITY_MAP = {
  kyu_11: 1,
  kyu_10: 2,
  kyu_9: 3,
  kyu_8: 4,
  kyu_7: 5,
  kyu_6: 6,
  kyu_5: 7,
  kyu_4: 8,
  kyu_3: 9,
  kyu_2: 10,
  kyu_1: 11,
  dan_1: 12,
  dan_2: 13,
  dan_3: 14,
  dan_4: 15,
  dan_5: 16,
  dan_6: 17,
  dan_7: 18,
  dan_8: 19,
  dan_9: 20,
  dan_10: 21,
};

export const USER_TYPE_OPTIONS = [
  { id: USER_TYPES.superManager, label: 'Менеджер клуба' },
  { id: USER_TYPES.manager, label: 'Адміністратор клуба' },
  { id: USER_TYPES.trainer, label: 'Тренер' },
  { id: USER_TYPES.sportsmen, label: 'Спортсмен' },
];

export const USER_STATUS_OPTIONS = [
  { id: USER_STATUS.active, label: BASE_STATUS_TITLES[USER_STATUS.active] },
  { id: USER_STATUS.deleted, label: BASE_STATUS_TITLES[USER_STATUS.deleted] },
  { id: USER_STATUS.archived, label: BASE_STATUS_TITLES[USER_STATUS.archived] },
  { id: USER_STATUS.blocked, label: BASE_STATUS_TITLES[USER_STATUS.blocked] },
];

export const CONTRIBUTION_STATUS_OPTIONS = [
  { id: CONTRIBUTION_STATUS.passed, label: t`Здав внесок` },
  { id: CONTRIBUTION_STATUS.not_passed, label: t`Не здав внесок` },
];
